import React, { useEffect, useMemo } from 'react';

import config from 'config';
import PropTypes from 'prop-types';

import { useIntl } from '../../../../techstyle-shared/react-intl';
import { Script } from '../../../../techstyle-shared/react-marketing';

const widgetBtnStyle = {
  scale: [0.5, 0.5],
  vPosition: ['90%', '90%'],
  color: {
    main: '#1C4BB6',
    second: '#FFFFFF',
  },
  icon: { type: 11, shape: 'circle' },
};

export function EqualWebSnippet({
  position = 'right',
  btnStyle = widgetBtnStyle,
  ...rest
}) {
  const { locale } = useIntl();
  const menuLang = useMemo(() => locale.split('-')[0].toUpperCase(), [locale]);
  const equalWebSitekeys = config.get('public.equalWeb.siteKeys');
  const equalWebSitekey = equalWebSitekeys[locale];

  useEffect(() => {
    if (!window.interdeal) {
      // sets interdeal if not already set
      window.interdeal = {
        sitekey: equalWebSitekey,
        Position: position,
        Menulang: menuLang,
        btnStyle,
        draggable: false,
        domains: {
          js: 'https://aacdn.nagich.com/',
          acc: 'https://access.nagich.com/',
        },
      };
    }
  }, [menuLang, position, equalWebSitekey, btnStyle]);

  // Clean up the dom element the equalweb script creates so that the widget
  // gets removed when EqualWebSnippet is no longer rendered.
  useEffect(() => {
    return () => {
      const domElement = window.interdeal?.INDshadowRootWrap;
      if (domElement) {
        document.body.removeChild(domElement);
      }
    };
  }, []);

  return (
    <Script
      async
      crossOrigin="anonymous"
      data-cfasync="true"
      globalScriptKey="ada-widget"
      integrity="sha512-PUyQFF3HFjRiVfjOiFFu+RTc0nGmLV5FN3CVw8zWFK6pVbWPAEKy9X2bTUn10GNu1EbxN56MuWu0P8ZHC6xv3Q=="
      skipServerRender
      src="https://aacdn.nagich.com/core/5.1.2/accessibility.js"
      defer="true"
      {...rest}
    />
  );
}

EqualWebSnippet.propTypes = {
  /**
   * Button style for the widget menu.
   */
  btnStyle: PropTypes.object,
  /**
   * Position for widget menu.
   */
  position: PropTypes.oneOf(['left', 'right']),
};

export default React.memo(EqualWebSnippet);
